import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const fetchFaq = () => {
  return Api(endPoints.fetchFaq, null, requestType.GET);
};

export const createFaq = (params) => {
  return Api(endPoints.createFaq, params, requestType.POST);
};
export const updateFaq = (id, params) => {
  return Api(`${endPoints.updateFaq}/${id}`, params, requestType.PUT);
};
export const deleteFaq = (id) => {
  return Api(`${endPoints.deleteFaq}/${id}`, null, requestType.DELETE);
};
